import baseReport from '../baseReport';
import _ from 'lodash';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarAssinatura = (professores) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
    /* {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [{ text: 'Obs.: ', bold: true }, 'Este rel. apresenta todas as aulas cadastradas correspondente a disciplina.'],
    }, */
  ];
};

const perfilTurmaReport = async ({ date, time, filtros, data, periodos, periodo, tipoDeEnsino,  indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Perfil da Turma' });

  const dataFormated = [];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhum perfil da turma encontrado.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  for (const i in data) {
    let nameProfessores = data[i].professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
    nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

    let nameDisciplina = _.orderBy(data[i].disciplinas);
    nameDisciplina = nameDisciplina.reduce((total, key) => `${total}${key}, `, '');
    nameDisciplina = nameDisciplina.substring(0, nameDisciplina.length - 2);

   // let labelDiciplina = (data[i].disciplinas.length > 1 && tipoDeEnsino === 'F')?'Disciplinas: ':'Disciplina: ';
    let labelDiciplina = (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I')?'Campos de Experiência: ' : (data[i].disciplinas.length > 1 && tipoDeEnsino === 'F')?'Disciplinas: ':'Disciplina: ';
    let labelProfessor = (data[i].professores.length > 1)?'Professores/Educadores: ':'Professor/Educador: ';

    const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

    dataFormated.push([
      {
        text: filtros.nmescola,
        bold: true,
        fontSize: 12,
        alignment: 'center',
        margin: [0, 10, 0, 5],
      },
      {
        fontSize: 9,
        text: [
          { text: labelProfessor, bold: true },
          nameProfessores,
        ],
      },
      {
        fontSize: 9,
        columns: [
          {
            text: [
              { text: 'Ano letivo:  ', bold: true },
              filtros.aaletivo,
              ...AnoSubsquente
            ],
          },
          {
            alignment: 'right',
            text: [
              { text: 'Turma:   ', bold: true },
              filtros.turma,
            ],
          },
        ],
      },
      {
        fontSize: 9,
        margin: [0, 15, 0, 0],
        columns: [
          {
            alignment: 'justify',
            text: [
              { text: labelDiciplina, bold: true },
              nameDisciplina,
            ],
          },
        ],
      },
      {
        text: data[i].descricaoperfil,
        style: 'descricao'
      },
      ...montarAssinatura(data[i].professores),

    ]);

    if(i < (data.length-1))
      dataFormated.push({text: '', pageBreak: 'before'});

  }

  return {
    ...headerFooter,
    content: [
      ...dataFormated,
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
        alignment: 'center',
      },
      descricao:{
        fontSize: 9,
        margin: [3, 20, 0, 3],
        alignment: 'justify',
      },
    },
  };
};

export default perfilTurmaReport;
